module.exports = __webpack_public_path__ + "img/copy.f7f8a2ac.svg";